import React from 'react'
import { useSelector } from 'react-redux'
import { getBatteryPercentage } from '../../../../utils'
import Icon from '@mdi/react'
import {
    mdiBattery,
    mdiBattery90,
    mdiBattery70,
    mdiBattery50,
    mdiBattery30,
    mdiBattery10,
    mdiBatteryOutline
} from '@mdi/js'

export default function Battery(props) {
    const { theme } = useSelector(state => state.main)

    const { value } = props

    const percentage = getBatteryPercentage(value)

    switch (true) {
        case percentage === 100:
            return (
                <Icon
                    path={mdiBattery}
                    size={1}
                    rotate={90}
                    color={theme.active}
                />
            )
        case percentage < 100 && percentage > 80:
            return (
                <Icon
                    path={mdiBattery90}
                    size={1}
                    rotate={90}
                    color={theme.active}
                />
            )
        case percentage <= 80 && percentage > 60:
            return (
                <Icon
                    path={mdiBattery70}
                    size={1}
                    rotate={90}
                    color={theme.active}
                />
            )
        case percentage <= 60 && percentage > 40:
            return (
                <Icon
                    path={mdiBattery50}
                    size={1}
                    rotate={90}
                    color={theme.active}
                />
            )
        case percentage <= 40 && percentage > 9:
            return (
                <Icon
                    path={mdiBattery30}
                    size={1}
                    rotate={90}
                    color={theme.active}
                />
            )
        case percentage <= 9 && percentage > 0:
            return (
                <Icon
                    path={mdiBattery10}
                    size={1}
                    rotate={90}
                    color={theme.error}
                />
            )
        case percentage === 0:
            return (
                <Icon
                    path={mdiBatteryOutline}
                    size={1}
                    rotate={90}
                    color={theme.error}
                />
            )
        default:
            return (
                <Icon
                    path={mdiBattery}
                    size={1}
                    rotate={90}
                    color={theme.active}
                />
            )
    }
}
